import { runInAction, makeAutoObservable } from 'mobx';
import { userHandler } from '../handlers/userHandler';
import LoadingProgressStore from './LoadingProgressStore';
import SnackbarStore from './SnackbarStore';
import { severity } from '../utils/severity';

class UserStore {
  users = [];
  isLoading = false;
  createUserStatus = false;
  updateUserStatus = false;
  setUserImageStatus = false;
  userImage = null;
  isUserImageLoaded = false;
  isUserNameExist = false;
  isEmailExist = false;
  refreshUsersBoard = 1;
  error = '';

  constructor() {
    makeAutoObservable(this);
  }

  async fetchUsersDropDown() {
    this.isLoading = true;
    userHandler
      .fetchUsersDropDown()
      .then((response) => {
        runInAction(() => {
          this.users = response.data;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      })
      .finally(() => {
        runInAction(() => {
          this.isLoading = false;
        });
      });
  }

  async createUser(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return userHandler
      .createUser(payload)
      .then((response) => {
        runInAction(() => {
          this.createUserStatus = true;
          this.refreshUsersBoard += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'User created successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.createUserStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateUser(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return userHandler
      .updateUser(payload)
      .then((response) => {
        runInAction(() => {
          this.updateUserStatus = true;
          this.refreshUsersBoard += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'User updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateUserStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async fetchUserImage() {
    userHandler
      .fetchUserImage()
      .then((response) => {
        runInAction(() => {
          this.userImage = response.data.returnValue;
          this.isUserImageLoaded = true;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      });
  }

  async checkUserNameExists(userName) {
    userHandler
      .checkUserExists(userName, null)
      .then((response) => {
        runInAction(() => {
          this.isUserNameExist = response.data.returnValue;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      });
  }

  async checkEmailExists(email) {
    userHandler
      .checkUserExists(null, email)
      .then((response) => {
        runInAction(() => {
          this.isEmailExist = response.data.returnValue;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      });
  }

  async setUserImage(base64Image) {
    LoadingProgressStore.toggleIsLoading(true);
    userHandler
      .setUserImage(base64Image)
      .then((response) => {
        runInAction(() => {
          this.setUserImageStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Profile picture updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.setUserImageStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }
}

export default new UserStore();
